var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',_vm._g({ref:"loadableButton",class:`vs-con-loading__container ${_vm.className}`,attrs:{"color":_vm.color,"disabled":_vm.disabled || _vm.loadingState,"size":_vm.size,"type":_vm.type,"icon":_vm.icon,"icon-pack":_vm.iconPack,"icon-after":_vm.iconAfter}},_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }